import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  SubscriptionApi,
  SubscriptionCancelCommand,
  SubscriptionInitPaymentCommand,
  SubscriptionInitPaymentResponseDto,
  SubscriptionPromocodeApi,
  SubscriptionPromocodeDto,
  SubscriptionResponseDto,
} from "api";

const subscriptionApi = new SubscriptionApi();
const subscriptionPromocodeApi = new SubscriptionPromocodeApi();

export enum SubscriptionKeys {
  PROMOCODE = "PROMOCODE",
  PROMOCODE_TIMESTAMP = "PROMOCODE_TIMESTAMP",
}

export interface SubscriptionState {
  showLayoutBanner: boolean;
  showSidebarBanner: boolean;
  subscription: SubscriptionResponseDto | null;
}

const initialState: SubscriptionState = {
  showLayoutBanner: false,
  showSidebarBanner: false,
  subscription: null,
};

export const getSubscriptionPromocode = createAsyncThunk<
  SubscriptionPromocodeDto,
  string
>("subscription/promocode/get", async (promocode) => {
  const { data } = await subscriptionPromocodeApi.apiSubscriptionPromocodeGet(
    promocode
  );
  return data;
});

export const getSubscription = createAsyncThunk<SubscriptionResponseDto>(
  "subscription/get",
  async () => {
    const { data } = await subscriptionApi.apiSubscriptionGet();
    return data;
  }
);

export const initSubscriptionPayment = createAsyncThunk<
  SubscriptionInitPaymentResponseDto,
  SubscriptionInitPaymentCommand
>("subscription/init", async (body) => {
  const { data } = await subscriptionApi.apiSubscriptionPaymentInitPost(body);

  return data;
});

export const cancelSubscription = createAsyncThunk<
  void,
  SubscriptionCancelCommand
>("subscription/cancel", async (body) => {
  const { data } = await subscriptionApi.apiSubscriptionCancelPost(body);
  return data;
});

const ibanAccountSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setShowLayoutBanner: (state, action) => {
      state.showLayoutBanner = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSubscription.fulfilled, (state, action) => {
      const { isTrial, isExpired, subscriptionDurationDays } = action.payload;

      // Show banners only for trial with less than 7 days left or expired subscriptions
      state.showLayoutBanner =
        (isTrial && subscriptionDurationDays <= 7) || isExpired;

      state.showSidebarBanner =
        (isTrial && subscriptionDurationDays <= 7) || isExpired;

      state.subscription = action.payload;
    });
    builder.addCase(cancelSubscription.fulfilled, (state) => {
      state.subscription = null;
    });
  },
});

export const { setShowLayoutBanner } = ibanAccountSlice.actions;

export default ibanAccountSlice.reducer;
